// versionUtils.js
export const isBackendNewer = (backendVersion, frontendVersion) => {
    const backendParts = backendVersion.split('.').map(Number);
    const frontendParts = frontendVersion.split('.').map(Number);
    const maxLength = Math.max(backendParts.length, frontendParts.length);
  
    for (let i = 0; i < maxLength; i++) {
      const b = backendParts[i] || 0;
      const f = frontendParts[i] || 0;
      if (b > f) {
        return true;
      }
      if (b < f) {
        return false;
      }
    }
    return false;
  };
  
  export const checkAndSetVersionMismatch = (data) => {
    // Prefer the "version" or "currentVersion" keys
    const backendVersion = data?.version || data?.currentVersion;
    const frontendVersion = process.env.REACT_APP_VERSION;
    
    // If no version is supplied by the API, do nothing
    if (!backendVersion) return;
  
    if (isBackendNewer(backendVersion, frontendVersion)) {
      localStorage.setItem("versionMismatch", "true");
      localStorage.setItem("newVersion", backendVersion);
      // Dispatch an event so that the notification component (and others) can update.
      window.dispatchEvent(new Event("versionMismatch"));
    } else {
      // Clear the flag if backend is no longer newer.
      localStorage.removeItem("versionMismatch");
      localStorage.removeItem("newVersion");
    }
  };
  